import { Colors } from "assets/colors";

export const styles: any = {
  inputLight: {
    width: "100%",
    margin: ".5rem 0",
    boxShadow: "none",
    padding: ".5rem .7rem",
    border: `1px solid ${Colors.BorderGray}`,
    borderRadius: "5px"
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "white",
    borderRadius: "5px",
    border: `1px solid ${Colors.BorderGray}`,
    color: Colors.BorderGray,
    height: "36px",
    width: "265px",
    marginRight: "1rem",
    "& input": {
      border: "none",
      padding: ".4rem",
      "&:focus": {
        outline: "none"
      }
    }
  },
  buttonGreenOutline: {
    color: Colors.Green,
    border: `1px solid ${Colors.Green}`,
    textTransform: "capitalize",
    borderRadius: "5px",
    "&:hover": {
      backgroundColor: Colors.HoverGreen,
    }
  },
  buttonGreen: {
    color: "white",
    border: `none`,
    backgroundColor: Colors.Green,
    textTransform: "capitalize",
    padding: '7px 25px',
    borderRadius: "5px",
    "&:hover": {
      backgroundColor: Colors.HoverGreen,
      color: Colors.Green
    }
  },
  buttonOrange: {
    color: "white",
    border: `none`,
    backgroundColor: Colors.OrangeIcon,
    textTransform: "capitalize",
    borderRadius: "5px",
    "&:hover": {
      backgroundColor: Colors.OrangeIcon,
      color: "white"
    }
  },
  serachContainerOverlay: {
    display: "flex",
    position: "absolute",
    top: '142px',
    right: '15px',
    alignItems: "start",
    backgroundColor: "white",
    borderRadius: "5px",
    border: `1px solid ${Colors.BorderGray}`,
    color: Colors.BorderGray,
    height: "500px",
    width: "318px",
    padding: '20px',
    zIndex:1030,
    shadow: "5px 5px 5px #000"
  }
}
